import React from 'react'

import NavigationMenuSection from "../../../menu-items/section/section"
import NavigationMenuItem, {CounterType} from "../../../menu-items/menu-item"
import Workspace from "../../../../../core/model2/space/workspaces/workspace";

type Props = {
    workspace   : Workspace,
}

export default function NavigationMenu_WorkspaceSettings(props:Props) {

    const openInfo = () => {
        gd.navigation.goToProject(props.workspace.project.id, '/info')
    }

    const openSettings = () => {
        gd.navigation.goToProject(props.workspace.project.id, '/info/settings')
    }

    const openUsers = () => {
        gd.navigation.goToProject(props.workspace.project.id, '/info/users')
    }

    return (
        <NavigationMenuSection name="Workspace" systemName={props.workspace.id+"-settings"} collapsible={true} counter={3} className="">
            <NavigationMenuItem name="Workspace Info" icon="ii5-information" onClick={openInfo} />
            <NavigationMenuItem name="Users & Access" icon="i5-users" onClick={openUsers} counter={props.workspace.project.usersTotal} counterStyle={CounterType.GRAY_NUMBER} />
            <NavigationMenuItem name="Settings" icon="i5-settings" onClick={openSettings} />
        </NavigationMenuSection>
    )

}
